/**
 * StepIndicator Atom Component
 * Circle indicator for step navigation
 */

import { cn } from '@/lib/utils'

interface StepIndicatorProps {
	number: number
	isActive?: boolean
	isCompleted?: boolean
	className?: string
}

export function StepIndicator({
	number,
	isActive = false,
	isCompleted = false,
	className,
}: StepIndicatorProps) {
	return (
		<div
			className={cn(
				'flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full border-2 font-["Bricolage_Grotesque"] text-xl md:text-2xl font-black transition-colors',
				isActive
					? 'bg-[#CDFF00] border-[#CDFF00] text-[#09194D]'
					: isCompleted
					? 'bg-[#09194D] border-[#09194D] text-white'
					: 'bg-white border-[#09194D] text-[#09194D]',
				className
			)}
		>
			{number}
		</div>
	)
}
